<template>
  <div>
    <div
      ref="swiperMain"
      class="swiper swiper-main"
      :id="`swiper-main__${leadId}_${imageId}`"
    >
      <div class="swiper-wrapper">
        <div
          v-for="(image, idx) of images"
          :key="`${image}_${idx}`"
          class="swiper-slide swiper-main__slide"
        >
          <VideoPlayer
            v-if="isVideoSlide(idx)"
            class="swiper-main__slide__win"
            :id="`player_${leadId}_${imageId}`"
            :src="image"
            :isSlider="false"
          />
          <img
            v-else-if="images.includes('not_images')"
            src="/images/Photo.png"
            class="swiper-main__slide__win"
          />

          <OneImage
            v-if="!isVideoSlide(idx) && !images.includes('not_images')"
            :src="fullImageUrl(leadId, image)"
            :realSlideIdx="realSlideIdx"
            :galleryIdx="idx"
          />
        </div>
      </div>
      <a
        class="swiper-control-next"
        :class="isVideoSlideAcive ? 'swiper-nav-flex' : ''"
      >
        <span class="swiper-control-next__icon" />
      </a>
      <a
        class="swiper-control-prev"
        :class="isVideoSlideAcive ? 'swiper-nav-flex' : ''"
      >
        <span class="swiper-control-prev__icon" />
      </a>
      <div class="swiper-pagination" />
    </div>

    <div
      v-if="this.galleryOption === 'avito'"
      ref="swiperThumb"
      class="swiper swiper-thumb"
      :id="`swiper-thumb__${leadId}_${imageId}`"
    >
      <div class="swiper-wrapper swiper-thumbs">
        <div
          v-for="(image, idx) of images"
          :key="`${image}_${idx}`"
          class="swiper-slide cursor-pointer swiper-thumb__slide"
        >
          <div v-if="isVideoSlide(idx)" class="swiper-thumb__slide__win">
            <img
              :src="getVideoThumb(image)"
              class="swiper-thumb__slide__win__img"
            />
          </div>
          <div v-else class="swiper-thumb__slide__win">
            <img v-if="images.includes('not_images')" src="/images/Photo.png" />
            <img
              v-else
              :data-src="fullImageThumbUrl(leadId, image)"
              class="swiper-thumb__slide__win__img swiper-lazy"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import Swiper, { Navigation, Thumbs, Lazy, Pagination } from 'swiper'
import 'swiper/css/bundle'
import VideoPlayer from './VideoPlayer/VideoPlayer.vue'
import OneImage from './OneImage.vue'
import { metrikaEvents } from '../../../../services/metrika'

Swiper.use([Navigation, Pagination, Thumbs, Lazy])

export default {
  name: 'Swiper',
  props: {
    leadId: Number,
    imageId: Number,
    images: Array,
    videoField: Object,
    positionVideo: String,
    imagesHost: String,
    galleryOption: String,
    isActive: Boolean,
  },
  components: {
    VideoPlayer,
    OneImage,
  },
  watch: {
    isActive() {
      if (!this.isActive) return
      this.thumbs?.swiper.lazy.load()
      this.thumbs?.swiper.lazy.loadInSlide(0)
    },
  },
  methods: {
    getVideoThumb(link) {
      return ['vk.com', 'vkvideo.ru'].some((h) => link.includes(h))
        ? '/images/vkvideo.webp'
        : '/images/youtube.png'
    },
    isVideoSlide(idx) {
      if (this.imageId !== 0) return false
      return (
        this.videoField &&
        ((this.positionVideo === 'first' && idx === 0) ||
          (this.positionVideo === 'last' && idx === this.images.length - 1))
      )
    },
    fullImageUrl(leadId, imageUrl) {
      const image = imageUrl || ''
      return image.includes('http')
        ? image
        : `${this.imagesHost}${leadId}/${image}`
    },
    fullImageThumbUrl(leadId, imageUrl) {
      const image = imageUrl || ''
      return image.includes('http')
        ? image
        : `${this.imagesHost}${leadId}/thumb/${image}`
    },
  },
  computed: {
    isVideoSlideAcive() {
      const active = this.activeSlideIdx
      const iLength = this.images.length
      const normalizedIdx =
        ((active > iLength ? active % iLength : active) || iLength) - 1

      return this.isVideoSlide(normalizedIdx)
    },
  },
  setup() {
    const activeSlideIdx = ref(1)
    const realSlideIdx = ref(0)

    return {
      activeSlideIdx,
      realSlideIdx,
      thumbs: null,
    }
  },
  mounted() {
    const { swiperMain, swiperThumb } = this.$refs

    const thumbs = this.galleryOption === 'avito' && {
      swiper: new Swiper(`#${swiperThumb.id}`, {
        slidesPerView: 11,
        preloadImages: false,
        lazy: {
          checkInView: true,
        },
        grid: {
          rows: 1000,
          fill: 'row',
        },
        on: {
          touchEnd(s) {
            const range = 5
            const diff =
              s.touches.diff === s.isHorizontal()
                ? s.touches.currentX - s.touches.startX
                : s.touches.currentY - s.touches.startY
            if (diff < range || diff > -range) {
              s.allowClick = true
            }
          },
        },
      }),
    }
    this.thumbs = thumbs

    const swiper = new Swiper(`#${swiperMain.id}`, {
      spaceBetween: 35,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      preloadImages: false,
      lazy: {
        preloaderClass: 'spinner-lazy-preloader',
        checkInView: true,
      },
      navigation: {
        nextEl: '.swiper-control-next',
        prevEl: '.swiper-control-prev',
      },
      breakpoints: {
        1024: {
          pagination: false,
        },
      },
      thumbs,
    })
    swiper.on('activeIndexChange', (sw) => {
      const from = this.realSlideIdx + 1
      const to = sw.realIndex + 1
      this.activeSlideIdx = sw.activeIndex
      this.realSlideIdx = sw.realIndex
      metrikaEvents.onChangeImage(from, to)
    })
  },
}
</script>

<style scoped>
@import '@/assets/swiper.css';

.swiper-thumbs {
  transform: none !important;
}
.swiper-nav-flex {
  display: flex !important;
}

.swiper-pagination-bullet {
  width: 20px;
  height: 3px;
  border-radius: 0%;
  background: rgba(0, 0, 0, 0.2);
}
.swiper-pagination-bullet-active {
  color: #fff;
  background: #007aff;
}
.swiper-pagination-fraction {
  bottom: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px;
  font-size: 0.7rem;
  font-weight: bold;
  color: #fff;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 2px;
  width: 5vh;
  height: 3vh;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
